module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete":"Delete","hide":"Hide","show":"Show","edit":"Rename"}}')
  delete Component.options._Ctor
}
